import { IPerfObservers } from './types';

export const perfObservers: IPerfObservers = {};
